<template>
  <iframe v-if="src!==''" :src="src" class="center-screen" name="iFrameUserManagement" id="iFrameUserManagement"
          style="z-index: 999999999">
  </iframe>
</template>

<script lang="ts" setup>
import {ref, watch} from "vue";
import store from "@km/store";
import {UserModuleNames} from "@km/components/user/UserModulesAnimations";
import {UserManagementConnectorRoutes} from "@k/global/UserManagementConnectorRoutes";
import {EventListener} from "@k/global/eventVerteiler";
import {INTERFRAMEMESSAGES} from "@k/global/InterframeMessages";


function getIframeSRC(openUserModule: UserModuleNames) {
  switch (openUserModule) {
    case UserModuleNames.login:
      return UserManagementConnectorRoutes.getURL("login");
    case UserModuleNames.logout:
      return UserManagementConnectorRoutes.getURL("logout");
    case UserModuleNames.forgot_username:
      return UserManagementConnectorRoutes.getURL("accountrecovery");
    case UserModuleNames.reset_password:
      return UserManagementConnectorRoutes.getURL("passwordrecovery");
    case UserModuleNames.change_email:
      return UserManagementConnectorRoutes.getURL("changeEmail");
    case UserModuleNames.adressen:
      return UserManagementConnectorRoutes.getURL("adresses");


    case UserModuleNames.registration:
      return UserManagementConnectorRoutes.getURL("register");
    case UserModuleNames.orders:
      return "";


    case UserModuleNames.forgot_password:
      return UserManagementConnectorRoutes.getURL("adresses");
    case UserModuleNames.add_address:
      return UserManagementConnectorRoutes.getURL("adresses");
    case UserModuleNames.edit_address:
      return UserManagementConnectorRoutes.getURL("adresses");
    case UserModuleNames.closed:
      return "";
    case UserModuleNames.account:
      return UserManagementConnectorRoutes.getURL("myaccount");

  }
}

const listener = new EventListener();


const src = ref("");
watch(() => store.getters.getOpenUserModules, (newVal: UserModuleNames) => {
  src.value = getIframeSRC(newVal);
});
listener.addEventListener(INTERFRAMEMESSAGES.USERMANAGEMENT_CLOSE, () => {
  store.commit("CLOSE_ALL_USERLAYER")
})
    .addEventListener(INTERFRAMEMESSAGES.OPEN_BESTELLUNGEN, () => {
      store.commit("OPEN_USERLAYER", UserModuleNames.orders)
    })
    .addEventListener(INTERFRAMEMESSAGES.USERMANAGEMENT_REGISTRATION_SUCCESS, () => store.commit("CLOSE_USERLAYER", UserModuleNames.registration))


</script>


<style scoped lang="scss">
iframe {
  position: absolute;
  width: 100%;
  height: 100%;
}

</style>
